var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDangerTriangle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.69066 2.3065L1.20522 13.1334C1.07151 13.365 1.00075 13.6275 1.00001 13.8949C0.999257 14.1623 1.06854 14.4253 1.20095 14.6576C1.33337 14.8899 1.52431 15.0835 1.75477 15.2191C1.98523 15.3547 2.24718 15.4276 2.51456 15.4305H15.4854C15.7528 15.4276 16.0148 15.3547 16.2452 15.2191C16.4757 15.0835 16.6666 14.8899 16.799 14.6576C16.9315 14.4253 17.0007 14.1623 17 13.8949C16.9992 13.6275 16.9285 13.365 16.7948 13.1334L10.3093 2.3065C10.1728 2.08147 9.98064 1.89542 9.7513 1.76629C9.52195 1.63717 9.2632 1.56934 9 1.56934C8.7368 1.56934 8.47805 1.63717 8.2487 1.76629C8.01936 1.89542 7.82716 2.08147 7.69066 2.3065Z",
    stroke: "#F26233",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 6.24219V9.30497",
    stroke: "#F26233",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.3677H9.00766",
    stroke: "#F26233",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerTriangle);
export default __webpack_public_path__ + "static/media/danger-triangle.6d57ddba86332d035ae9506a5891c1a6.svg";
export { ForwardRef as ReactComponent };